// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Js_promise = require("rescript/lib/js/js_promise.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_format = require("rescript/lib/js/caml_format.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var Querystringify = require("querystringify");
var JsxRuntime = require("react/jsx-runtime");
var RescriptReactRouter = require("@rescript/react/src/RescriptReactRouter.res.js");
var Http$ReactHooksTemplate = require("../common/http.res.js");
var Image$ReactHooksTemplate = require("../common/image.res.js");
var Project$ReactHooksTemplate = require("./project.res.js");
var FormModal$ReactHooksTemplate = require("./FormModal.res.js");
var SurveyList$ReactHooksTemplate = require("./SurveyList.res.js");
var ProjectForm$ReactHooksTemplate = require("./ProjectForm.res.js");
var ProjectList$ReactHooksTemplate = require("./ProjectList.res.js");
var Notification$ReactHooksTemplate = require("../common/Notification.res.js");
var SurveySummaryCards$ReactHooksTemplate = require("./SurveySummaryCards.res.js");

function fetchProjects(currentSearchKey) {
  var url = currentSearchKey !== undefined ? "/api/v1/projects/?search=" + currentSearchKey : "/api/v1/projects/";
  return Http$ReactHooksTemplate.fetchGetJSONDecode(url, (function (param) {
                return Json_decode.field("projects", (function (param) {
                              return Json_decode.list(Project$ReactHooksTemplate.fromJson, param);
                            }), param);
              }));
}

function Projects(props) {
  var match = React.useState(function (param) {
        return "GetSurveys";
      });
  var setState = match[1];
  var state = match[0];
  var match$1 = React.useState(function (param) {
        
      });
  var setSelectedProject = match$1[1];
  var selectedProject = match$1[0];
  var match$2 = React.useState(function (param) {
        
      });
  var setNotification = match$2[1];
  var notification = match$2[0];
  var match$3 = React.useState(function (param) {
        return false;
      });
  var setAlert = match$3[1];
  var match$4 = React.useState(function (param) {
        return "";
      });
  var setErrors = match$4[1];
  var match$5 = React.useState(function (param) {
        return "Create";
      });
  var setAction = match$5[1];
  var action = match$5[0];
  var match$6 = React.useState(function (param) {
        return false;
      });
  var setToggleProjectForm = match$6[1];
  var match$7 = React.useState(function (param) {
        return false;
      });
  var setLiveOnly = match$7[1];
  var liveOnly = match$7[0];
  var match$8 = React.useState(function (param) {
        return SurveySummaryCards$ReactHooksTemplate.empty();
      });
  var setSurveyStats = match$8[1];
  var queryParams = Querystringify.parse(props.urlParams);
  var x = Js_dict.get(queryParams, "search");
  var currentSearchKey = x !== undefined && x !== "" ? x : undefined;
  var match$9 = React.useState(function (param) {
        return currentSearchKey;
      });
  var setSearchKey = match$9[1];
  var x$1 = Js_dict.get(queryParams, "selectedProjectId");
  var selectedProjectId = x$1 !== undefined && x$1 !== "" ? Caml_format.int_of_string(x$1) : undefined;
  var handleProjectSearchChange = function (value) {
    Curry._1(setSearchKey, (function (param) {
            if (value === "") {
              return ;
            } else {
              return value;
            }
          }));
  };
  var toggleProjectCreate = function (param) {
    Curry._1(setAction, (function (param) {
            return "Create";
          }));
    Curry._1(setToggleProjectForm, (function (param) {
            return true;
          }));
  };
  React.useEffect((function (param) {
          Js_promise.then_((function (projects) {
                  Curry._1(setState, (function (param) {
                          return {
                                  TAG: "Ready",
                                  _0: projects
                                };
                        }));
                  var tmp;
                  if (selectedProjectId !== undefined) {
                    var project = List.find_opt((function (x) {
                            return Caml_obj.equal(Project$ReactHooksTemplate.id(x), selectedProjectId);
                          }), projects);
                    if (project !== undefined) {
                      tmp = Curry._1(setSelectedProject, (function (param) {
                              return project;
                            }));
                    } else {
                      var redirectUrl = currentSearchKey !== undefined ? "/projects/all?search=" + currentSearchKey : "/projects/all";
                      setTimeout((function (param) {
                              RescriptReactRouter.push(redirectUrl);
                            }), 4000);
                      tmp = Curry._1(setAlert, (function (param) {
                              return true;
                            }));
                    }
                  } else {
                    tmp = Curry._1(setSelectedProject, (function (param) {
                            return Belt_List.head(projects);
                          }));
                  }
                  return Promise.resolve(tmp);
                }), fetchProjects(undefined));
        }), [
        action,
        selectedProjectId
      ]);
  var handelProjectSubmission = function (project) {
    var projectId = Project$ReactHooksTemplate.id(project);
    var params = {};
    params["project"] = Project$ReactHooksTemplate.toJson(project);
    var formSubmitUrl;
    formSubmitUrl = action === "Create" ? Http$ReactHooksTemplate.fetchPostJSON("/api/v1/projects", params) : Http$ReactHooksTemplate.fetchPostJSON("/api/v1/projects/" + String(Belt_Option.getExn(projectId)) + "/update", params);
    Js_promise.then_((function (response) {
            var status = Json_decode.field("status", (function (param) {
                    return Json_decode.withDefault("failed", Json_decode.string, param);
                  }), response);
            if (status === "success") {
              RescriptReactRouter.push("/projects/all");
              window.location.reload();
            } else {
              Curry._1(setErrors, (function (param) {
                      return "Something went wrong. Please contact admin";
                    }));
            }
            return Promise.resolve();
          }), formSubmitUrl);
  };
  if (typeof state !== "object") {
    return JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("img", {
                        className: "h-8 w-8",
                        src: Image$ReactHooksTemplate.dashboardLoading
                      }),
                  JsxRuntime.jsx("span", {
                        children: "Loading projects...",
                        className: "ml-3 text-sm text-aurometalsaurus"
                      })
                ],
                className: "min-h-screen flex items-center justify-center bg-ghostwhiteblue"
              });
  }
  var tmp;
  if (match$6[0]) {
    var tmp$1;
    tmp$1 = action === "Create" ? "Create New Project" : "Update Project";
    var tmp$2;
    tmp$2 = action === "Create" ? Project$ReactHooksTemplate.empty() : Belt_Option.getExn(selectedProject);
    tmp = JsxRuntime.jsx(FormModal$ReactHooksTemplate.make, {
          title: tmp$1,
          onClose: (function (param) {
              Curry._1(setToggleProjectForm, (function (param) {
                      return false;
                    }));
            }),
          children: JsxRuntime.jsx(ProjectForm$ReactHooksTemplate.make, {
                toggleProjectForm: (function (param) {
                    Curry._1(setToggleProjectForm, (function (param) {
                            return false;
                          }));
                  }),
                selectedProject: tmp$2,
                onSubmit: handelProjectSubmission
              })
        });
  } else {
    tmp = JsxRuntime.jsx(JsxRuntime.Fragment, {});
  }
  return JsxRuntime.jsxs("div", {
              children: [
                notification !== undefined ? JsxRuntime.jsx("div", {
                        children: JsxRuntime.jsx(Notification$ReactHooksTemplate.make, {
                              text: notification[0],
                              isError: notification[1],
                              handleClose: (function (param) {
                                  Curry._1(setNotification, (function (param) {
                                          
                                        }));
                                })
                            }),
                        className: "pt-1"
                      }) : JsxRuntime.jsx(JsxRuntime.Fragment, {}),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx(ProjectList$ReactHooksTemplate.make, {
                              searchValue: Belt_Option.getWithDefault(match$9[0], ""),
                              onSearchChange: handleProjectSearchChange,
                              projects: state._0,
                              selectedProjectId: selectedProjectId,
                              setSelectedProject: setSelectedProject,
                              alert: match$3[0],
                              toggleProjectCreate: toggleProjectCreate
                            }),
                        JsxRuntime.jsxs("div", {
                              children: [
                                selectedProject !== undefined ? JsxRuntime.jsx("div", {
                                        children: JsxRuntime.jsxs("div", {
                                              children: [
                                                JsxRuntime.jsxs("div", {
                                                      children: [
                                                        JsxRuntime.jsx("p", {
                                                              children: "Selected Project",
                                                              className: "text-xs font-semibold uppercase tracking-wide text-aurometalsaurus mb-1"
                                                            }),
                                                        JsxRuntime.jsxs("div", {
                                                              children: [
                                                                JsxRuntime.jsx("h2", {
                                                                      children: Project$ReactHooksTemplate.name(selectedProject),
                                                                      className: "truncate text-xl lg:text-2xl font-semibold text-darkcharcoal",
                                                                      title: Project$ReactHooksTemplate.name(selectedProject)
                                                                    }),
                                                                JsxRuntime.jsx("button", {
                                                                      children: JsxRuntime.jsx("img", {
                                                                            className: "h-4 w-4 mx-auto opacity-70",
                                                                            src: Image$ReactHooksTemplate.edit
                                                                          }),
                                                                      className: "flex-shrink-0 w-8 h-8 rounded-lg hover:bg-ghostwhiteblue focus:outline-none focus:ring-2 focus:ring-pigmentblue",
                                                                      style: {
                                                                        outline: "None"
                                                                      },
                                                                      title: "Edit project",
                                                                      type: "button",
                                                                      onClick: (function (param) {
                                                                          Curry._1(setAction, (function (param) {
                                                                                  return "Update";
                                                                                }));
                                                                          Curry._1(setToggleProjectForm, (function (param) {
                                                                                  return true;
                                                                                }));
                                                                        })
                                                                    })
                                                              ],
                                                              className: "flex items-center gap-2 min-w-0"
                                                            })
                                                      ],
                                                      className: "min-w-0 flex-1"
                                                    }),
                                                JsxRuntime.jsx("div", {
                                                      children: JsxRuntime.jsx(SurveySummaryCards$ReactHooksTemplate.Row.make, {
                                                            stats: match$8[0],
                                                            liveOnly: liveOnly,
                                                            onLiveToggle: (function (param) {
                                                                Curry._1(setLiveOnly, (function (prev) {
                                                                        return !prev;
                                                                      }));
                                                              }),
                                                            compact: true
                                                          }),
                                                      className: "w-full xl:max-w-2xl flex-shrink-0"
                                                    })
                                              ],
                                              className: "flex flex-col xl:flex-row xl:items-start xl:justify-between gap-4"
                                            }),
                                        className: "border-b border-gray-200 px-4 sm:px-6 lg:px-30-px py-4 lg:py-5 bg-white flex-shrink-0"
                                      }) : JsxRuntime.jsx(JsxRuntime.Fragment, {}),
                                selectedProject !== undefined ? JsxRuntime.jsx("div", {
                                        children: JsxRuntime.jsx(SurveyList$ReactHooksTemplate.make, {
                                              selectedProject: selectedProject,
                                              liveOnly: liveOnly,
                                              setLiveOnly: (function (value) {
                                                  Curry._1(setLiveOnly, (function (param) {
                                                          return value;
                                                        }));
                                                }),
                                              onStatsChange: (function (stats) {
                                                  Curry._1(setSurveyStats, (function (param) {
                                                          return stats;
                                                        }));
                                                })
                                            }),
                                        className: "flex-1 min-h-0"
                                      }) : JsxRuntime.jsx(JsxRuntime.Fragment, {})
                              ],
                              className: "projects-page-main flex flex-col"
                            })
                      ],
                      className: "flex flex-col projects-page-row"
                    }),
                tmp
              ],
              className: "projects-page-layout"
            });
}

var make = Projects;

exports.fetchProjects = fetchProjects;
exports.make = make;
/* react Not a pure module */
